import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo, useState } from "react";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CarPageContent } from "@app/components/PageContent";
import { CarAssetClassSelector } from "@app/components/AssetClassSelector";
import { useSimulationModelsHistory } from "./useSimulationModelsHistory";
import { SimulationModelsHistoryTable } from "./SimulationModelsHistoryTable";
import { SimulationModelsHistoryChart } from "./SimulationModelsHistoryChart";
import { CarButton, CarDownloadButton } from "@app/components/Buttons";
import { CarChipGroup } from "@app/components/Chip";

export const SimulationModelsHistory = memo(() => {
  const pageContent = usePageContent();
  const data = useSimulationModelsHistory();

  return (
    <TablePlaceHolder
      isLoading={pageContent.isLoading || data.assetClassSelector.isLoading}
      rows={8}
    >
      <CarPageContent
        sx={{ mb: 3 }}
        content={pageContent.getContent(
          CarPageContentCode.SIMULATION_ANALYSIS_MODELS_HISTORY,
        )}
        isWhiteContext
      />
      <Box sx={{ mt: 2, display: "flex", gap: 5, alignItems: "flex-end" }}>
        <CarAssetClassSelector
          sx={{
            width: 300,
            ".MuiInputBase-input": {
              backgroundColor: "white",
            },
          }}
          label="Select Asset Class"
          {...data.assetClassSelector}
        />
      </Box>
      <TablePlaceHolder sx={{ mt: 5.75 }} isLoading={data.isLoading} rows={8}>
        <Typography variant="h6SemiBold" sx={{ mt: 6, ml: 10, mb: -0.5 }}>
          {data.assetClassSelector.selectedItem?.name ?? ""}
        </Typography>
        <SimulationModelsHistoryChart
          items={data.items}
          hiddenFields={data.hiddenFields}
        />
        <CarChipGroup
          sx={{ ml: 10, mt: -3.75, alignSelf: "flex-start" }}
          direction="row"
          items={[
            {
              label: "Mu",
              value: "mu",
              isChecked: !data.hiddenFields.includes("mu"),
            },
            {
              label: "Sigma",
              value: "sigma",
              isChecked: !data.hiddenFields.includes("sigma"),
            },
          ]}
          onClick={(value) => {
            if (data.hiddenFields.includes(value)) {
              data.setHiddenFields(
                data.hiddenFields.filter((i) => i !== value),
              );
            } else {
              data.setHiddenFields([...data.hiddenFields, value]);
            }
          }}
        />
        <CarDownloadButton
          sx={{ mt: -3.75, ml: "auto" }}
          disabled={data.hiddenFields.length >= 2}
          onClick={data.handleDownloadReports}
        >
          Download Reports
        </CarDownloadButton>
        <SimulationModelsHistoryTable
          items={data.items}
          sx={{ mt: 10 }}
          hiddenFields={data.hiddenFields}
        />
      </TablePlaceHolder>
    </TablePlaceHolder>
  );
});
